/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import { Box, Heading, Stack, Text } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';
import page from 'page';

/**
 * Internal dependencies
 */
import CardGrid from 'components/card-grid';
import ConnectionCard from './connection-card';

/**
 * Style dependencies
 */
import './styles.scss';

const ConnectionsCardGrid = ({ connections, items = [] }) => {
    const itemRenderer = ConnectionCard;

    let gridItems = map(connections, (item) => ({
        key: item.id,
        renderer: itemRenderer,
        onClick: ({ id }) => page('/connections/' + id),
        ...item,
    }));


    gridItems = [...gridItems, ...items];

    return <CardGrid className='connections-card-grid' columns='2' items={gridItems} />;
};

export default ConnectionsCardGrid;
